import { Outlet } from "react-router-dom";
import useAuthentication from "./hooks/useAuthentication";
import usePageTracker from "../hooks/usePageTracker";
import useLinguaDelProfilo from "../hooks/useLinguaDelProfilo";

import LoadingScreen from "./loadingScreen/loadingScreen";
// Il banner dei cookie (CookieSolution) non sta piu' qui: dal 08/10/2026
// (STU-480) lo monta router.js sopra TUTTE le rotte, anche quelle pubbliche
// fuori da Root (/maturita, /sicurezza, /blog, /welcome, /payment-*...).
// Riacceso il 10/09/2026 (STU-326) dopo mesi commentato: senza quel componente
// `window._iub` non esiste mai, quindi `hasMarketingConsent()` e' sempre falso.

const Root = () => {
  const { loader } = useAuthentication();

  // Traccia automaticamente le pagine visitate
  usePageTracker();

  // La lingua del profilo vale su ogni dispositivo appena si entra (STU-529).
  useLinguaDelProfilo();

  // PERF (LCP): il render-gate ora si risolve appena lo stato di auth è noto e
  // (per gli utenti loggati) il profilo è in Redux, NON più dopo il getDoc
  // separato di verifica email/password che prima era serializzato sul critical
  // path. Per gli utenti NON loggati il gate si apre immediatamente alla prima
  // callback di onAuthStateChanged → la landing dipinge subito senza attendere
  // alcun round-trip Firestore. ProtectedRoute continua a gestire l'accesso
  // alle route /home/*, quindi non si espone contenuto riservato.
  if (loader) return <LoadingScreen />;

  return <Outlet />;
};

export default Root;
